import Vue from 'vue'
import Vuex from 'vuex'

import { pages } from '@/config/pagesConfig'
Vue.use(Vuex)

export default new Vuex.Store({
  state: { // variables that we want to store
    user: {},
    userFirebase: {},
    userLists: [],
    pages: pages
  },

  // functions to retrive the state with some modification (es. variable * 2)
  getters: {
    getListById:(state) => (id) => {
        return state.userLists.length && state.userLists.find(list => list.id === id);
    }
  },

  mutations: { // functions to change the value of the state variables
    authUser(state, user) {
      state.user = user;
    },
    authUserFirebase(state, userFirebase) {
      state.userFirebase = userFirebase;
    },
    userLists(state, lists) {
      state.userLists = lists;
    },
    pages(state, pages) {
      state.pages = pages;
    }
  },
  actions: { // functions to make commits to mutation in async
    fetchUser({ commit }, user) {
      if (user) {
        commit("authUser", user);
      } else {
        commit("authUser", null);
      }
    },
    fetchUserFirebase({ commit }, userFirebase) {
      if (userFirebase) {
        commit("authUserFirebase", userFirebase);
      } else {
        commit("authUserFirebase", null);
      }
    },
    fetchUserLists({ commit }, lists) {
      if (lists) {
        commit("userLists", lists);
      } else {
        commit("userLists", null);
      }
    },
    fetchPages({ commit }, pages) {
      commit("pages", pages);
    },
    fetchLogoutSetup({ commit }) {
      commit("authUser", null);
      commit("authUserFirebase", null);
      commit("userLists", null);
    },
  }
})